// extracted by mini-css-extract-plugin
export default {"brandPromo":"ZG-z","carousel":"_G-z"};